import type { FC } from 'react';
import Link from 'next/link';
import { Avatar, Flex, Text } from '@eqi-investimentos/react';
export const CardProfileLabelAvatar: FC<CardProfileLabelAvatarProps> = ({
  title,
  label,
  path,
  onClick
}) => {
  return <Flex as={Link} href={path} className="animate-fade" gap="2.5" mb="1.875rem" w="full" minH="3.125rem" sx={{
    '.chakra-avatar': {
      w: '40px',
      h: '40px'
    }
  }} data-sentry-element="Flex" data-sentry-component="CardProfileLabelAvatar" data-sentry-source-file="index.tsx">
      <Avatar name={title} showLabels={false} data-sentry-element="Avatar" data-sentry-source-file="index.tsx" />
      <Flex flexDir="column" justifyContent="center" gap="4" data-sentry-element="Flex" data-sentry-source-file="index.tsx">
        <Text className="container__title_card_profile" maxW="10rem" fontSize="0.9375rem" fontWeight="bold" lineHeight="1.125rem" color="content.brand" noOfLines={1} onClick={onClick} data-sentry-element="Text" data-sentry-source-file="index.tsx">
          {title}
        </Text>
        <Text className="container__label_card_profile" fontSize="0.8125rem" fontWeight="medium" lineHeight="0.9375rem" color="content.secondary" data-sentry-element="Text" data-sentry-source-file="index.tsx">
          {label}
        </Text>
      </Flex>
    </Flex>;
};
type CardProfileLabelAvatarProps = {
  title: string;
  label: string;
  path: string;
  onClick?: () => void;
};